import React, { Fragment, Component } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { doSignIn } from '../store/AuthSlice.tsx';
import { Navigate } from 'react-router-dom';
import Slider from "react-slick";

import bg1 from "../assets/utils/images/originals/city.jpg";
import bg2 from "../assets/utils/images/originals/citydark.jpg";
import bg3 from "../assets/utils/images/originals/citynights.jpg";

import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";

const authStateToProps = (state) => ({    
  isAuthenticated : state.auth.isAuthenticated,
  user : state.auth.user,
  error  : state.auth.error,
});

class Login extends Component {
    constructor(props) {
      super(props);
      this.inputUsernameRef = React.createRef();
      this.inputPasswordRef = React.createRef();
    }

  handleSubmit = e => {      
        e.preventDefault();
        let username = this.inputUsernameRef.current.value;
        let password = this.inputPasswordRef.current.value ;
        this.props.signIn({ username, password});
  };

  render() {    
    if (this.props.isAuthenticated)
    {
        localStorage.setItem('isReloaded', true);
        window.location.reload(true);
    }

    let isReloaded = localStorage.getItem('isReloaded');

    if (isReloaded !== null && isReloaded) return <Navigate to="/" replace={true} />;

    let settings = {
      dots: true,
      infinite: true,
      speed: 500,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      initialSlide: 0,
      autoplay: true,
      adaptiveHeight: true,
    };
    return (
      <Fragment>
        <div className="h-100">
          <Row className="h-100 g-0">
            <Col lg="4" className="d-none d-lg-block">
              <div className="slider-light">
                <Slider {...settings}>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-plum-plate">
                    <div className="slide-img-bg"
                      style={{
                        backgroundImage: "url(" + bg1 + ")",
                      }}/>
                    <div className="slider-content">
                      <h3>Perfect Balance</h3>
                      <p>
                        ArchitectUI is like a dream. Some think it's too good to
                        be true! Extensive collection of unified React Boostrap
                        Components and Elements.
                      </p>
                    </div>
                  </div>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-premium-dark">
                    <div className="slide-img-bg"
                      style={{
                        backgroundImage: "url(" + bg3 + ")",
                      }}/>
                    <div className="slider-content">
                      <h3>Scalable, Modular, Consistent</h3>
                      <p>
                        Easily exclude the components you don't require.
                        Lightweight, consistent Bootstrap based styles across
                        all elements and components
                      </p>
                    </div>
                  </div>
                  <div className="h-100 d-flex justify-content-center align-items-center bg-sunny-morning">
                    <div className="slide-img-bg opacity-6"
                      style={{
                        backgroundImage: "url(" + bg2 + ")",
                      }}/>
                    <div className="slider-content">
                      <h3>Complex, but lightweight</h3>
                      <p>
                        We've included a lot of components that cover almost all
                        use cases for any type of application.
                      </p>
                    </div>
                  </div>
                </Slider>
              </div>
            </Col>
            <Col lg="8" md="12" className="h-100 d-flex bg-white justify-content-center align-items-center px-3">
              <Col lg="9" md="10" sm="12" className="mx-auto app-login-box">
                <div className="app-logo" />
                <h4 className="mb-0">
                  <div>Welcome back,</div>
                  <span>Please log in to your account.</span>
                </h4>                
                <Row className="divider" />
                <div className="alert alert-warning" role="alert">
                  Database revert to initial state every day.
                </div>
                <div>
                  Please use below credentials
                  <ul className="list-unstyled">
                      <li>Username : demo</li>
                      <li>Password : demo</li>
                  </ul>                  
                </div>
                <div>
                  <Form  onSubmit={this.handleSubmit} >
                    {(this.props.error !== null && this.props.error.allErrorMessages !== undefined) &&
                        <Row>
                            <Col lg="6">
                                <div className="alert alert-danger" role="alert">
                                    {this.props.error.allErrorMessages}
                                </div>
                            </Col>
                        </Row>
                    }
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Username</Label>
                          <Input innerRef={this.inputUsernameRef} type="text" id="username" placeholder="Username..."/>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="examplePassword">Password</Label>
                          <Input innerRef={this.inputPasswordRef} type="password" id="password" placeholder="Password..."/>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="divider" />
                    <div className="d-flex align-items-center">
                      <div className="ms-auto">
                        {/* <a href="https://colorlib.com/" onClick={(e) => e.preventDefault()} className="btn-lg btn btn-link" >
                          Recover Password
                        </a>{" "} */}
                        <Button color="primary" size="lg" type="submit">
                          Login
                        </Button>
                      </div>
                    </div>
                  </Form>
                </div>
              </Col>
            </Col>
          </Row>
        </div>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  signIn: (payload) => dispatch(doSignIn(payload)),
});

export default connect(authStateToProps, mapDispatchToProps)(Login);